import React, { useState, useEffect } from "react";
import ResponsiveAppBar from "../../components/AppBar";
import TemporaryDrawer from "../../components/DrawerPesquisar";
import DataTable from "../../components/Table";
import { consultarBanco } from "../../Services";
import moment from "moment";
import AddNotification from "../../components/Snackbars";
import { Notify } from "../../components/Notify/index.tsx"
import { usePostHog } from "posthog-js/react";

const ExportarPesquisas = () => {
  const posthog = usePostHog();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState([]);
  const [filtros, setFiltros] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState({ size: 100, number: 0, count: 1 });
  const [allSelected, setAllSelected] = React.useState(false);

  const [notification, setNotification] = useState({
    message: "",
    open: false,
    severity: "",
    action: {},
  });
  const [clearHeader, setClearHeader] = useState(false);

  const onPageChange = (e) => setPage({ ...page, number: e });

  const handlePageSize = (e) => {
    setPage({ ...page, size: e, number: 0 });
  };

  const filtrarConsulta = async (e, usePage = false) => {
    if (loading) {
      return;
    }


    let _data = Object.assign({}, e);

    Object.keys(_data).forEach(key => {
  if (typeof _data[key] === 'string') {
    _data[key] = _data[key].trim();
  }
});

    if (_data?.matServ?.length < 4) {
      setNotification({
        message:
          "Digite ao menos três letras para realizar a busca de material ou serviço!",
        open: true,
        severity: "warning",
      });
      return;
    }

    setLoading(true);

    if (Object.values(_data).length < 1) {
      setLoading(false);
      return;
    }

    _data.dataInicial = _data.dataInicial
      ? moment(_data.dataInicial).format("YYYY-MM-DD")
      : moment().subtract(12, "months").format("YYYY-MM-DD");
    _data.dataFinal = moment(_data.dataFinal)
      .startOf("day")
      .add(23, "hours")
      .add(59, "minutes");
    _data.registros = page.size;
    _data.pagina = usePage ? page.number : 0;

    if (_data?.valorMin) {
      if (isNaN(_data?.valorMin))
        _data.valorMin = Number(
          _data.valorMin.replace("R$", "").replaceAll(".", "").replace(",", ".")
        );
    }

    if (_data?.valorMax) {
      if (isNaN(_data?.valorMax))
        _data.valorMax = Number(
          _data.valorMax.replace("R$", "").replaceAll(".", "").replace(",", ".")
        );
    }
    const inicioBusca = Date.now()
    const res = await consultarBanco(_data);
    const fimBusca = Date.now()

    setLoading(false);

    let infosBusca = {
      orgao: sessionStorage.getItem('orgao') || "",
      razaoSocial: sessionStorage.getItem('razaoSocial') || "",
      usuario: sessionStorage.getItem('user') || "",
      busca: e.matServ,
      filtro: _data,
      data: new Date(Date.now()).toLocaleString(),
      tempoBuscaSegundos: (fimBusca - inicioBusca) / 1000,
      adm: sessionStorage.getItem('isAdm') 
    }

    if (res.success) {
      setData(res.data);
      posthog?.capture("busca", {
        ...infosBusca,
        sucesso: true,
        resultados: res.total
      });
      setPage((page) => ({
        ...page,
        count: res.registros,
        number: usePage ? page.number : 0,
      }));
    } else {
      posthog?.capture("busca", {
        ...infosBusca,
        sucesso: false,
        resultados: 0,
        resposta: res
      });
      setData([]);
      setPage((page) => ({ ...page, count: 0, number: 0 }));
    }
    setAllSelected(false);
    // setSelected([]);
    // setHeader({
    //   media: 0,
    //   mediana: 0,
    //   maiorValor: 0,
    //   menorValor: 0,
    // });
    setFiltros(_data);
  };

  const handleNotification = (message, open, severity, action = null) => {
    setNotification({
      message: message,
      open: open,
      severity: severity,
      action: action,
    });
  };

  useEffect(() => {
    filtrarConsulta(filtros, true);
  }, [page.number, page.size]);


  const [showNotify, setShowNotify] = useState(true)


  return (
    <>
      <AddNotification
        notification={notification}
        setNotification={setNotification}
      />
      <ResponsiveAppBar />
      <div className="container-pesquisa-precos">
        <TemporaryDrawer
          getData={filtrarConsulta}
          open={open}
          setOpen={setOpen}
        // clearHeader={() => setClearHeader(true)}
        />
        {/* {showNotify && (
  <Notify
    type="warning"
    title="Sistema em atualização!"
    message={`Prezados clientes, estamos ampliando nossa base de dados e melhorando o sistema de busca. Por isso, lentidão e instabilidades podem ocorrer temporariamente.
  Agradecemos a compreensão.`}
    onClose={() => setShowNotify(false)}
  />
)} */}
        <div className="inner-container-pesquisa-precos" >
          <DataTable
            data={data}
            setData={setData}
            loading={loading}
            addNotification={handleNotification}
            openPesquisar={open}
            page={page}
            filters={filtros}
            handlePageSize={handlePageSize}
            onPageChange={onPageChange}
            clearHeader={clearHeader}
            setClearHeader={setClearHeader}
          />

        </div>
      </div>
    </>
  );
};

export default ExportarPesquisas;
